<template>
  <v-container>
    <v-card class="elevation-2 mx-auto" :loading="loading" max-width="600">
      <v-card-title>Update Profile</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-10">
        <form>
          <!-- <v-row>
           <v-col cols="12" md="6" sm="12" class="py-0">
              <v-autocomplete
                v-model="form_data.category_id"
                :error-messages="form_error.category_id"
                :items="categories"
                item-text="name"
                item-value="category_id"
                label="Category"
                outlined
                dense
                multiple
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" sm="12" class="py-0">
              <v-text-field
                v-model="form_data.title"
                :error-messages="form_error.title"
                label="Title"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="form_data.company_name"
                :error-messages="form_error.company_name"
                label="Company Name"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <!-- <v-col cols="12" md="6" sm="12" class="py-0">
              <v-text-field
                v-model="form_data.phone_number"
                :error-messages="form_error.phone_number"
                label="Phone number"
                outlined
                dense
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-row class="pb-5">
            <v-col cols="12">
              <label>Company description</label>
              <vue-editor
                v-model="form_data.company_desc"
                :editor-toolbar="customToolbar" 
                placeholder="Company Description"               
              />
              <p v-if="getLength() > 200" class="red--text mt-3 mb-0">
                The company description will be less than 200 Characters
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0 mb-0">
              <v-file-input
                accept="image/jpeg,image/png,image/gif"
                v-model="form_data.booth_logo"
                :error-messages="form_error.booth_logo"
                label="Ballroom logo"
                outlined
                dense
                readonly
              ></v-file-input>
            </v-col>
            <v-col cols="12" v-if="booth_logo_link">
              Current Booth Logo
              <v-img 
                :src="booth_logo_link"
                width="250px"
                style="border: 1px solid lightgray; height: 180px !important;"
                contain
                class="mb-5"
              />
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="form_data.company_address"
                :error-messages="form_error.company_address"
                label="Address"
                outlined
                dense
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row> -->
          <v-row class="mt-2">
            <v-col cols="12" class="py-0 pt-1">
              <v-text-field
                v-model="form_data.email"
                :error-messages="form_error.email"
                label="Company Email"
                outlined
                dense
                readonly
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="6" sm="12" class="py-0">
              <v-text-field
                v-model="form_data.sponsor_type"
                :error-messages="form_error.sponsor_type"
                label="Sponsorship Level"
                outlined
                dense
                readonly
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" class="py-0 pt-1">
              <v-text-field
                v-model="form_data.request_info_email"
                :error-messages="form_error.request_info_email"
                label="Request Info Email"
                outlined
                dense
                hint="Use comma to add multiple emails. for e.g. joe@mailinator.com,doi@mailinator.com"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" md="6" sm="12" class="my-0 py-1">
              <v-text-field
                v-model="form_data.social_links.facebook"
                :error-messages="form_error['social_links.facebook']"
                label="Facebook Link"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12" class="my-0 py-1">
              <v-text-field
                v-model="form_data.social_links.linkedin"
                :error-messages="form_error['social_links.linkedin']"
                label="Linkedin Link"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12" class="my-0 py-1">
              <v-text-field
                v-model="form_data.social_links.twitter"
                :error-messages="form_error['social_links.twitter']"
                label="X Link"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12" class="my-0 py-1">
              <v-text-field
                v-model="form_data.social_links.instagram"
                :error-messages="form_error['social_links.instagram']"
                label="Instagram Link"
                outlined
                dense
              ></v-text-field>
            </v-col>
          
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12" class="my-0 py-1">
              <v-text-field
                v-model="form_data.social_links.youtube"
                :error-messages="form_error['social_links.youtube']"
                label="Youtube Link"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" class="py-0">
              <v-text-field
                v-model="form_data.meta.title"
                label="Meta Title"
                outlined
                dense
                hint="displayed on search engine result pages and browser tabs to indicate the topic of a page."
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-2">
              <v-text-field
                v-model="form_data.meta.description"
                label="Meta Description"
                outlined
                dense
                hint="description of page used by search engine"
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn
            class="mr-4"
            color="secondary"
            @click="updateProfile"
            :loading="loading"
            :disabled="loading || getLength() > 200"
            >Update</v-btn
          >
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import { VueEditor } from "vue2-editor";
import { unescape } from 'underscore';

// import { extend } from 'vee-validate';
export default {
  name: "Login",
  data() {
    return {
      form_error: {},
      form_data: {
        company_desc: "",
        social_links:[],
        category_id : [],
        booth_logo: null
      },
      booth_colors: [
        { name: "Red", color: "red" },
        { name: "Red-Orange", color: "red_orange" },
        { name: "Orange", color: "orange" },
        { name: "Yellow", color: "yellow" },
        { name: "Yellow-Orange", color: "yellow_orange" },
        { name: "Yellow-Green", color: "yellow_green" },
        { name: "Green", color: "green" },
        { name: "Blue-Green", color: "blue_green" },
        { name: "Blue", color: "blue" },
        { name: "Blue-Violet", color: "blue_violet" },
        { name: "Violet", color: "violet" },
        { name: "Red-Violet", color: "red_violet" },
      ],
      file: "",
      showPreview: false,
      imagePreview: "",
      user_data: null,
      vendor_id:'',
      username: null,
      name: null,
      email: null,
      loading: false,
      data: {},
      request_info_email: "",
      categories : [],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"]
      ],
      booth_logo_link: ""
    };
  },
  components:{
    VueEditor
  },
  watch : {
    "form_data.company_desc" :{
      handler(val){
        var div = document.createElement("div");
        div.innerHTML = val;
        let links = div.querySelectorAll('a')
        for(let i=0;i<links.length;i++){
          if (!/^https?:\/\//i.test(links[i].getAttribute('href'))) {
            div.querySelectorAll('a')[i].setAttribute('href','http://' + links[i].getAttribute('href'))
          }
        }
        this.form_data.company_desc_html = div.innerHTML
      }
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getLength() {
      var div = document.createElement("div");
      div.innerHTML = this.form_data.company_desc;
      return div.innerText.length;
    },
    updateProfile() {
      let _self = this;
      this.loading =true;
      this.form_data.company_desc = this.form_data.company_desc_html
      let arrSocial = [];
      for(let skey in _self.form_data.social_links){
        let value = _self.form_data.social_links[skey];
        value != "" ? arrSocial.push({name : skey ,link: value}) : null;
      }
      // this.form_data.social_links = arrSocial;

      let formData = new FormData();

      formData.append("name", this.form_data.name || "");
      formData.append("company_name",this.form_data.company_name || "");
      formData.append("company_desc",this.form_data.company_desc_html);
      formData.append("booth_logo",this.form_data.booth_logo || "");
      formData.append("email",this.form_data.email || "");
      formData.append("request_info_email",this.form_data.request_info_email || "");
      formData.append("meta",JSON.stringify(this.form_data.meta || { title: '', description: ''}));
      formData.append("social_links",JSON.stringify(arrSocial));

      this.$axios
        .put(`/vendor/update_profile/${this.vendor_id}`,formData)
        .then((response) => {
          console.log("response update",response)
          _self.form_error = {};
          let response_data = response.data;
          if (response_data.status) {
            this.data = response_data;
            _self.setAlert({
              show: true,
              variant: "success",
              message: response.data.message,
              dismissCountDown: 5000,
            });
            // this.user_data = response_data.user_data;
            _self.$router.push("/booth");
          } else {
            let errors = response_data.error;
            for (let key in errors) {
              console.log(errors[key]);
              _self.form_error[errors[key].field] = errors[key].message;
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
    htmlDecode(input){
      try {
        input = unescape(input);

        const parser = new DOMParser();

        const document = parser.parseFromString(input, "text/html");

        return document.firstChild.innerHTML;
      } catch (error) {
        return ""
      }
    },
    getVendorDetails() {
      this.loading = true;
      let _self = this;
      this.$axios.get(`/vendor/profiledetails`)
        .then((res) => {
          _self.form_error = {};
          if (res.status) {
            let data = res.data.data;
            for (let key in data) {
              _self.form_data[key] = data[key];
            }
            _self.form_data.request_info_email = _self.form_data.request_info_email ? _self.form_data.request_info_email : _self.form_data.email;
            !_self.form_data.meta ? _self.form_data.meta = { title: "", description: "" } : "";
            _self.form_data.company_desc = this.htmlDecode(_self.form_data.company_desc);
            _self.booth_logo_link = _self.form_data.booth_logo ? _self.getBoothLogoUrl(_self.form_data.booth_logo) : "";
          } else {
            let errors = res.error;
            for (let key in errors) {
              console.log(errors[key]);
              _self.form_error[errors[key].field] = errors[key].message;
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
    getBoothLogoUrl(filename) {
      return filename ? `${process.env.VUE_APP_RESOURCE_BASE_PATH}uploads/objects/${filename}` : "";
    }
  },
  mounted: function () {
    let localData = JSON.parse(localStorage.getItem('vendor_data'))
    this.vendor_id = localData.id;
    this.getVendorDetails();
  },
};
</script>